import { combineReducers } from 'redux';
import exerciseEntities from './exerciseEntities';
import localExercises from './localExercises';
export default combineReducers({
  exerciseEntities,
  localExercises
});